import React from 'react';
import PropTypes from 'prop-types';
import { uiState } from 'react-redux-ui-state';
import { withStyles } from '@material-ui/core';
import UsersIcon from '@material-ui/icons/PersonAdd';
import CertIcon from '@material-ui/icons/NoteAdd';
import Done from '@material-ui/icons/Done';
import NoCertIcon from '@material-ui/icons/NotInterested';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Card from '@material-ui/core/Card';
import Hidden from '@material-ui/core/Hidden';
import DatabasesIcon from '@material-ui/icons/Storage';

import roleDisabled from 'services/roleDisabled/index';
import RBACDeleteButton from 'components/RBACWrapper/RBACDeleteButton/RBACDeleteButton';
import { OWNER, ADMIN, OR_ADMIN, OR_SUPERUSER } from 'constants/roles';
import MoreLessString from 'components/MissionCtrl/ProfilePage/PersonalInfoTab/ApiTokenCard/ApiTokenItem/MoreLessString/MoreLessString';
import SegmentClickTracker from 'components/SegmentClickTracker/SegmentClickTrackerContainer';
import AddUserFormContainer from '../AddUserForm/AddUserFormContainer';
import FormToggleButton from '../FormToggleButton/FormToggleButton';
import PopoutItem from '../PopoutItem/PopoutItem';
import ORTable from '../ORTable/ORTable';
import { handleClickAway } from '../../services/handleClickAway/index';

const propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  certs: PropTypes.arrayOf(PropTypes.shape({})),
  clientCerts: PropTypes.arrayOf(PropTypes.shape({})),
  classes: PropTypes.shape({}).isRequired,
  instanceId: PropTypes.string.isRequired,
  instanceService: PropTypes.string.isRequired,
  deleteInstanceUser: PropTypes.func.isRequired,
  setUiState: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const defaultProps = {
  certs: [],
  clientCerts: [],
};

export function UnstyledUserList({
  users,
  certs,
  clientCerts,
  classes,
  instanceId,
  instanceService,
  deleteInstanceUser,
  setUiState,
  open,
  userRoles,
  page,
  rowsPerPage,
}) {
  function handleChangePage(event, newPage) {
    setUiState({
      page: newPage,
    });
  }

  const allowedUserRoles = [OWNER, ADMIN, OR_ADMIN, OR_SUPERUSER];
  let anchorEl;
  const handleClick = () => {
    setUiState({
      open: !open,
    });
  };

  const handDeleteClick = (id, service, username, db) => {
    if (db) {
      deleteInstanceUser(id, service, username, db);
    } else {
      deleteInstanceUser(id, service, username);
    }
  };

  const findCA = (user) => {
    const ca = certs.find((cert) => {
      const temp = cert.clientCertificates.some((clientCA) => clientCA.username === user.username);
      return temp;
    });
    // Return the entire item if any single sub item matches the username
    return ca;
  };

  const getAnchorEl = () => anchorEl;

  const setRef = (node) => {
    anchorEl = node;
  };

  const mobileUserCells = (user) => {
    if (instanceService === 'CockroachDB' || instanceService === 'MongoDB') {
      const ca = findCA(user);
      const clientCert = clientCerts.find((cc) => cc.username === user.username);
      let primary;
      if (!ca) {
        primary = '';
      } else if (ca.primary) {
        primary = 'Primary CA';
      } else {
        primary = 'Secondary CA';
      }
      const isValid = clientCert ? certs.find((ct) => ct.id === clientCert.caCertificate) : null;

      let validity;
      if (!clientCert) {
        validity = (
          <div className={classes.validity}>
            <NoCertIcon className={classes.mobileCertIcon} />
            <div className={classes.validityText}>No Certificate</div>
          </div>
        );
      } else if (isValid) {
        validity = (
          <div className={classes.validity}>
            <Done className={classes.mobileCertIcon} />
            <div className={classes.validityText}>Valid Certificate</div>
          </div>
        );
      } else {
        validity = (
          <div className={classes.validity}>
            <VerifiedUser className={classes.mobileCertIcon} />
            <div className={classes.validityText}>Invalid Certificate</div>
          </div>
        );
      }

      return (
        <React.Fragment>
          <div className={classes.mobileCertCell}>
            {user.database && (
              <div className={classes.validity}>
                <DatabasesIcon className={classes.mobileCertIcon} />
                <div className={classes.caTypeText}>{user.database}</div>
              </div>
            )}
            {primary && (
              <div className={classes.caType}>
                <CertIcon className={classes.mobileCertIcon} />
                <div className={classes.caTypeText}>{primary}</div>
              </div>
            )}
            {validity}
          </div>
        </React.Fragment>
      );
    }
    return null;
  };

  /**
   * the userCells variable is being commented out for now until
   * a refactor is done for the UserList to fit the comps better
   * in this ticket: UX-3703
   */

  // const userCells = (user) => {
  //   if (instanceService === 'CockroachDB' || instanceService === 'MongoDB') {
  //     const ca = findCA(user);
  //     const clientCert = clientCerts.find((cc) => cc.username === user.username);
  //     let primary;
  //     if (!ca) {
  //       primary = '';
  //     } else if (ca.primary) {
  //       primary = 'Primary CA';
  //     } else {
  //       primary = 'Secondary CA';
  //     }
  //     const isValid = clientCert ? certs.find((ct) => ct.id === clientCert.caCertificate) : null;

  //     let validity;
  //     if (!clientCert) {
  //       validity = (
  //         <div className={classes.certCell}>
  //           <NoCertIcon className={classes.certIcon} />
  //           No Certificate
  //         </div>
  //       );
  //     } else if (isValid) {
  //       validity = (
  //         <div className={classes.certCell}>
  //           <Done className={classes.certIcon} />
  //           Valid Certificate
  //         </div>
  //       );
  //     } else {
  //       validity = (
  //         <div className={classes.errorCertCell}>
  //           <VerifiedUser className={classes.certIcon} />
  //           Invalid Certificate
  //         </div>
  //       );
  //     }

  //     return (
  //       <React.Fragment>
  //         {user.database
  //         && (
  //         <TableCell align="left">
  //           <div className={classes.certCell} style={{ textAlign: 'left' }}>
  //             <DatabasesIcon className={classes.certIcon} />
  //             {user.database}
  //           </div>
  //         </TableCell>
  //         )}
  //         <TableCell align="left">
  //           <div className={classes.certCell}>
  //             {primary && <CertIcon className={classes.certIcon} />}
  //             {primary}
  //           </div>
  //         </TableCell>
  //         <TableCell align="left">
  //           {validity}
  //         </TableCell>
  //       </React.Fragment>
  //     );
  //   }
  //   return null;
  // };

  const addUserForm = (
    <AddUserFormContainer
      instanceId={instanceId}
      instanceService={instanceService}
      closePopout={handleClick}
    />
  );

  const addUserFormButton =
    users.length === 0 ? null : (
      <SegmentClickTracker buttonName="Users (Instance Details)">
        <FormToggleButton
          openForm={handleClick}
          setRef={setRef}
          label="USERS"
          icon={<UsersIcon />}
          disabled={roleDisabled(userRoles, allowedUserRoles)}
          tooltip="Add a User"
        />
      </SegmentClickTracker>
    );

  const embeddedAddUserForm =
    users.length === 0 ? (
      <Card className={classes.embeddedFormContainer}>
        <AddUserFormContainer instanceId={instanceId} instanceService={instanceService} />
      </Card>
    ) : null;

  const defaultUsersFilter = (user) => {
    if (
      (instanceService === 'CockroachDB' &&
        (user.username === 'admin' ||
          user.username === 'cluster_user' ||
          user.username === `_${instanceId.replace(/-/g, '_')}_cluster_admin`)) ||
      user.systemUser
    ) {
      return true;
    }
    return false;
  };

  const defaultUserText = (
    <div className={classes.defaultUserText}>
      <em>This is a Default user and they cannot be removed.</em>
    </div>
  );

  const usernameText = (user) => (
    <div className={classes.username}>
      <Hidden smDown>
        {user.username.length >= 40 ? (
          <MoreLessString lessChars={40} string={user.username} />
        ) : (
          user.username
        )}
      </Hidden>
      <Hidden mdUp>
        {user.username.length >= 20 ? (
          <MoreLessString lessChars={20} string={user.username} />
        ) : (
          user.username
        )}
      </Hidden>
    </div>
  );

  const defaultUserList = users.filter(defaultUsersFilter);
  const nonDefaultUserList = users.filter((user) => !defaultUsersFilter(user));

  /**
   * some code in both defaultUserItems and userItems
   * is being commented out for now until a refactor is done
   * for the UserList to fit the comps better in this ticket: UX-3703
   */

  const defaultUserItems =
    defaultUserList.length > 0 &&
    defaultUserList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user) => (
      <TableRow key={user.username}>
        <TableCell align="left">
          {usernameText(user)}
          {/* <Hidden mdUp> */}
          {defaultUserText}
          {/* </Hidden> */}
        </TableCell>
        {/* <Hidden smDown>
            <TableCell align="left" colSpan="1000">
              {defaultUserText}
            </TableCell>
          </Hidden> */}
        {/* <Hidden mdUp> */}
        <TableCell align="right">&nbsp;</TableCell>
        {/* </Hidden> */}
      </TableRow>
    ));

  const userItems = nonDefaultUserList
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    .map((user) => (
      <TableRow key={user.username}>
        <TableCell align="left">
          {usernameText(user)}
          {/* <Hidden mdUp> */}
          {mobileUserCells(user)}
          {/* </Hidden> */}
        </TableCell>
        {/* <Hidden smDown>
          {userCells(user)}
        </Hidden> */}
        <TableCell align="right">
          <RBACDeleteButton
            tooltip="Delete User"
            clear
            size="small"
            userAccess={userRoles}
            allowedAccess={allowedUserRoles}
            onClick={() =>
              handDeleteClick(
                instanceId,
                instanceService.toLowerCase(),
                user.username,
                user.database,
              )
            }
          />
        </TableCell>
      </TableRow>
    ));

  const userTable =
    users.length === 0 ? null : (
      <div className={classes.tableWrapper}>
        <ORTable
          className={classes.table}
          count={users.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
        >
          <TableBody>
            {defaultUserItems}
            {userItems}
          </TableBody>
        </ORTable>
      </div>
    );

  return (
    <div className={classes.listContainer}>
      {embeddedAddUserForm}
      <div className={classes.addUserButtonContainer}>
        &nbsp;
        <div className={classes.addUserButtonWrapper}>
          {addUserFormButton}
          <PopoutItem
            anchorEl={getAnchorEl}
            handleClick={handleClick}
            handleClickAway={(e) => handleClickAway(e, anchorEl, () => setUiState({ open: false }))}
            placement="bottom"
            open={open}
          >
            {addUserForm}
          </PopoutItem>
        </div>
      </div>
      {userTable}
    </div>
  );
}

UnstyledUserList.propTypes = propTypes;
UnstyledUserList.defaultProps = defaultProps;

const styles = (theme) => ({
  caType: {
    display: 'inline-block',
    position: 'relative',
  },
  caTypeText: {
    position: 'relative',
    left: '20px',
  },
  validity: {
    position: 'relative',
  },
  validityText: {
    position: 'relative',
    left: '20px',
  },
  username: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      minHeight: 'unset',
    },
    minHeight: theme.spacing(5),
    display: 'flex',
    alignItems: 'center',
    maxWidth: 'fit-content',
    fontSize: '14px',
  },
  defaultUserText: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
    fontStyle: 'italic',
    fontSize: '12px',
  },
  mobileCertCell: {
    color: theme.customColors.teal,
    fontStyle: 'italic',
    fontSize: theme.typography.caption.fontSize,
    textAlign: 'left',
  },
  mobileErrorCertCell: {
    color: theme.customColors.magenta,
    fontStyle: 'italic',
    fontSize: theme.typography.caption.fontSize,
    textAlign: 'left',
  },
  mobileCertIcon: {
    height: '15px',
    position: 'absolute',
    bottom: '4px',
  },
  certCell: {
    verticalAlign: 'middle',
    color: theme.customColors.teal,
    fontStyle: 'italic',
    fontSize: theme.typography.caption.fontSize,
    textAlign: 'center',
  },
  errorCertCell: {
    verticalAlign: 'middle',
    color: theme.customColors.magenta,
    fontStyle: 'italic',
    fontSize: theme.typography.caption.fontSize,
    textAlign: 'center',
  },
  certIcon: {
    marginBottom: `-${theme.spacing(0.75)}px`,
    marginRight: theme.spacing(0.25),
  },
  embeddedFormContainer: {
    maxWidth: '900px',
    marginRight: 'auto',
    marginLeft: 'auto',
    boxShadow: '3px 5px 5px 3px rgba(216,216,216,1)',
  },
  listItemDeleteRoot: {
    color: theme.customColors.white,
    backgroundColor: theme.customColors.red,
  },
  listContainer: {
    position: 'relative',
  },
  addUserButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    verticalAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    },
  },
  userlistHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  headerIcon: {
    display: 'flex',
    alignItems: 'center',
    color: theme.customColors.darkPurple,
    height: '35px',
    width: '35px',
  },
  headerText: {
    fontFamily: '"Libre Franklin Regular", sans-serif',
    fontSize: '21px',
  },
  table: {
    border: `1px solid ${theme.customColors.mediumGrey}`,
  },
  tableWrapper: {
    backgroundColor: theme.customColors.white,
    '& th': {
      height: 'unset',
      padding: theme.spacing(1),
    },
    '& td': {
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 0,
      paddingLeft: theme.spacing(1),
    },
  },
});

export const uiConfig = {
  name: 'userList',
  state: () => ({
    open: false,
    page: 0,
    rowsPerPage: 10,
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledUserList));
